import { ESaleType } from '../../../../../../../../../packages/api-models/common/json_query';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectNewbuildingSaleTypeFilter } from 'shared/selectors/advancedFilters';
import { NonEmptyArray } from '../../../../../../../../../packages/JsonQuery';
import { MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const NewbuildingSaleTypeContainer = () => {
  const { value, options } = useSelector(selectNewbuildingSaleTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleNewbuildingSaleTypesChange = useCallback(
    (newValue: NonEmptyArray<ESaleType> | null) => {
      onChange({ action: 'setNewbuildingSaleTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleNewbuildingSaleTypesChange} />
  );
};
